module.exports = __webpack_public_path__ + "media/images/sandbox/stage-product/stage-product-image-1-dcf29176472688983a48acdba7c40f49.png";